export enum HoursOfOperationHolidaysCondition {
    RegularHours,
    Closed,
    LimitedServices
}
